import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';

import { ErrorResponse } from '@components/pages/Organization/types';
import { removeGroupAdmin } from '@utils/backend-api/group-admins';
import { ORGANIZATION_DETAILS_KEY } from '@utils/backend-api/organizations';

const useGroupAdminRemove = () => {
  const queryClient = useQueryClient();

  return useMutation((id: number) => removeGroupAdmin(id), {
    onSuccess: ({ message }) => {
      toast.success(message);

      queryClient.invalidateQueries([ORGANIZATION_DETAILS_KEY]);
    },
    onError: (e: ErrorResponse) => {
      toast.error(e.message);
    },
  });
};

export default useGroupAdminRemove;
